import React, { useEffect } from 'react'
import './App.css'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import Routes from './route'
import { ApolloProvider } from '@apollo/client'

import client from './services/apollo'
import IdleTimeout from './component/common/idle.timeout'
import SessionStorage from './util/sessionstore'

const session = new SessionStorage()

function App(props) {
  // Arm the idle timeout only for a signed-in clinician — it must never run on
  // the login screen, where there is no session to end and a modal would be
  // nonsense.
  //
  // Two sources, deliberately. `props.token` is the reactive one: it appears on
  // LOGIN_SUCCESS and is cleared on LOGOUT, so the timer arms and disarms
  // without a reload. The sessionStorage read is the belt-and-braces half, for
  // a page reload — index.js seeds the store from the same place, but this
  // component is the first thing to actually depend on that path, so it does
  // not assume it.
  const storedToken = (session.getProfile() || {}).token
  const signedIn = Boolean(props.token || storedToken)

  return (
    <ApolloProvider client={client}>
      <IdleTimeout enabled={signedIn} />
      <Routes />
    </ApolloProvider>
  )
}

App.propTypes = {
  token: PropTypes.string,
}

const mapStateToProps = (state) => {
  // console.log(state);
  return {
    token: state.profile.token,
  }
}

export default connect(mapStateToProps, null)(App)
